export default function KpiTile({ label, value, sub, accent = 'brand' }) {
  const colors = {
    brand:   'bg-brand-50 text-brand-700',
    emerald: 'bg-emerald-50 text-emerald-700',
    amber:   'bg-amber-50 text-amber-700',
    slate:   'bg-slate-100 text-slate-700'
  }[accent] || 'bg-brand-50 text-brand-700';

  return (
    <div className="card p-4">
      <div className={`chip ${colors}`}>{label}</div>
      <div className="mt-2 text-2xl font-semibold">{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}
